import { APP_NAVIGATION } from '@/state/mutation-types'

const DESKTOP_SIDEBAR_STORAGE_KEY = 'sidebar_desktop_state'

const getSavedDesktopState = () => {
  const saved = localStorage.getItem(DESKTOP_SIDEBAR_STORAGE_KEY)
  return saved !== null ? JSON.parse(saved) : true
}

export default {
  state: window.initialSidebarState ?? {
      isSideBarOpen: false,
      isSideBarOpenDesktop: getSavedDesktopState(),
  },
  mutations: {
    [APP_NAVIGATION.UPDATE_SIDEBAR_OPEN_STATE](state, newOpenValue) {
      state.isSideBarOpen = newOpenValue
    },
    [APP_NAVIGATION.TOGGLE_SIDEBAR_OPEN_STATE](state) {
      state.isSideBarOpen = !state.isSideBarOpen
    },
    [APP_NAVIGATION.UPDATE_DESKTOP_SIDEBAR_OPEN_STATE](state, newOpenValue) {
      state.isSideBarOpenDesktop = newOpenValue
      localStorage.setItem(DESKTOP_SIDEBAR_STORAGE_KEY, JSON.stringify(newOpenValue))
    },
    [APP_NAVIGATION.TOGGLE_DESKTOP_SIDEBAR_OPEN_STATE](state) {
      state.isSideBarOpenDesktop = !state.isSideBarOpenDesktop
      localStorage.setItem(DESKTOP_SIDEBAR_STORAGE_KEY, JSON.stringify(state.isSideBarOpenDesktop))
    },
  },
}
